<template>
  <v-form class='wpsAsmeViewForm' v-model='valid' ref='wpsAsmeViewForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <div class="logo_box text-center">
            <img :src="$getCompanyData().url" height="150" width="200" />
          </div>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <h4>Welding Procedure Specification</h4>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Procedure No</label>
          <p>{{ wpsAsme.serial_no ? wpsAsme.serial_no : '-' }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Company Name</label>
          <p>{{ wpsAsme.company_name ? wpsAsme.company_name : '-' }}</p>
          <label class='view_label'>Company Address</label>
          <p>{{ wpsAsme.company_address ? wpsAsme.company_address : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Refrerred Standard</label>
          <p><v-chip small>{{ wpsAsme.referred_standard_name ? wpsAsme.referred_standard_name  : '-' }}</v-chip></p>
          <label class='view_label'>Supporting Pqrs</label>
          <p><v-chip small>{{ wpsAsme.pqr_name ? wpsAsme.pqr_name  : '-' }}</v-chip></p>
          <label class='view_label'>Welding Process</label>
          <p><v-chip small v-for="(item, index) in wpsAsme.wptwpr_id" :key="index">{{ item.text }}</v-chip></p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12' class="pt-0">
          <v-row>
            <v-col :cols='colValue' md='4' sm='6' xs='12'>
              <label class='view_label'>Rev Date</label>
              <p>{{ wpsAsme.rev_date ? wpsAsme.rev_date : '-' }}</p>
            </v-col>
            <v-col :cols='colValue' md='4' sm='6' xs='12'>
              <label class='view_label'>Rev No</label>
              <p>{{ wpsAsme.rev_no ? wpsAsme.rev_no  : '-' }}</p>
            </v-col>
          </v-row>
          <label class='view_label'>Welding Type</label>
          <p><v-chip small v-for="(item, index) in wpsAsme.wptwt_id" :key="index">{{ item.text }}</v-chip></p>
        </v-col>
      </v-row>
      <h4 class="text-center">Joint Design  (QW-402)</h4><hr>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Joint Design (QW-402)</label>
          <p>{{ wpsAsme.joint_design ? wpsAsme.joint_design  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="4" sm="6" xs="12">
          <label class='view_label'>Joint Backing</label>
          <p><template><v-chip :color="wpsAsme.joint_backing == 0 ? 'warning' : 'success'" small>{{ wpsAsme.joint_backing == 0 ? 'No' : 'Yes' }}</v-chip></template></p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Joint Backing Material Type</label>
          <p>{{ wpsAsme.joint_backing_material ? wpsAsme.joint_backing_material  : '-' }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols='colValue' md="12" xs="12">
          <label class='view_label'>Joint Drawings</label>
          <div class="upload_container">
            <v-row>
              <v-col v-for="(image, i) in wpsAsme.welding_procedure_drawing" :key="i" class="d-flex child-flex" cols="6">
                <div class="jointDrawings">
                  <v-row>
                    <v-col cols='12' md='5' sm='12' xs='12'>
                      <img height="150" width="200" :src="`${image.url}`" />
                    </v-col>
                    <v-col cols='12' md='7' sm='12' xs='12'>
                      <v-row>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>A : {{ image.param_a ? image.param_a : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>B : {{ image.param_b ? image.param_b : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>C : {{ image.param_c ? image.param_c : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>D : {{ image.param_d ? image.param_d : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>E : {{ image.param_e ? image.param_e : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>F : {{ image.param_f ? image.param_f : ''}}</p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <div class="break_page">
        <h4 class="text-center">Base Metals (QW-403)</h4><hr>
        <v-row v-for="(bm, bmi) in wpsAsme.base_metal" :key="bmi" class="pt-5">
          <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
            <v-row>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                <label class='view_label'>Base Metal</label>
                <p>{{ bm.base_metal ? bm.base_metal  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                <label class='view_label'>Name / Grade</label>
                <p>{{ bm.grade ? bm.grade  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Material Specification</label>
                <p>{{ bm.material_specification ? bm.material_specification  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>P No</label>
                <p>{{ bm.p_no ? bm.p_no  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Group No</label>
                <p>{{ bm.group_no ? bm.group_no  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Thickness</label>
                <p>{{ bm.thickness ? bm.thickness  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Groove Thickness Range</label>
                <p>{{ bm.groove_thickness_range ? bm.groove_thickness_range  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Fillet Thickness Range</label>
                <p>{{ bm.fillet_thickness_range ? bm.fillet_thickness_range  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Pipe Diameter Range</label>
                <p>{{ bm.pipe_diameter_range ? bm.pipe_diameter_range  : '-' }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <h4 class="text-center mt-2">Filler Metals (QW-404)</h4><hr>
      <v-row v-for="(fm, ind) in wpsAsme.filler_metal" :key="`fm_${ind}`" class="pt-5">
        <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Welding Process</label>
              <p><v-chip small>{{ fm.wps_text ? fm.wps_text  : '-' }}</v-chip></p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>F No</label>
              <p>{{ fm.f_no ? fm.f_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>A No</label>
              <p>{{ fm.a_no ? fm.a_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Spec No(SFA)</label>
              <p>{{ fm.spec_no ? fm.spec_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Aws Class</label>
              <p>{{ fm.aws_class ? fm.aws_class  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Size</label>
              <p>{{ fm.filler_size ? fm.filler_size  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Deposited Weld Metal Thickness</label>
              <p>{{ fm.deposited_weld_metal_thickness ? fm.deposited_weld_metal_thickness  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Groove</label>
              <p>{{ fm.groove ? fm.groove  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Fillet</label>
              <p>{{ fm.fillet ? fm.fillet  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Electrode Flux Clas</label>
              <p>{{ fm.electrode_flux_class ? fm.electrode_flux_class  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Remarks</label>
              <p>{{ fm.remarks ? fm.remarks  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Positions (QW-405)</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12'>
              <label class='view_label'>Position Of Groove</label>
              <p>{{ wpsAsme.position_of_groove ? wpsAsme.position_of_groove : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12'>
              <label class='view_label'>Position Of Filler</label>
              <p>{{ wpsAsme.position_of_fillet ? wpsAsme.position_of_fillet : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12'>
              <label class='view_label'>Welding Progression</label>
              <p>{{ wpsAsme.welding_progression ? wpsAsme.welding_progression : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Preheat (QW-406)</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Preheat Temperature Min</label>
              <p>{{ wpsAsme.preheat_temperature_min ? wpsAsme.preheat_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Preheat Temperature Max</label>
              <p>{{ wpsAsme.preheat_temperature_max ? wpsAsme.preheat_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Interpass Temperature Min</label>
              <p>{{ wpsAsme.interpass_temperature_min ? wpsAsme.interpass_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Interpass Temperature Max</label>
              <p>{{ wpsAsme.interpass_temperature_max ? wpsAsme.interpass_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Preheat Maintenance</label>
              <p>{{ wpsAsme.preheat_maintenance ? wpsAsme.preheat_maintenance  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Post Heat Treatment (QW-407)</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Postheat Temperature Min</label>
              <p>{{ wpsAsme.postheat_temperature_min ? wpsAsme.postheat_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Postheat Temperature Max</label>
              <p>{{ wpsAsme.postheat_temperature_max ? wpsAsme.postheat_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Time Min</label>
              <p>{{ wpsAsme.time_min ? wpsAsme.time_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Time Max</label>
              <p>{{ wpsAsme.time_max ? wpsAsme.time_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Remarks</label>
              <p>{{ wpsAsme.postheat_remark ? wpsAsme.postheat_remark  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Gas (QW-408)</h4><hr>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Shielding Gas</label>
              <p>{{ wpsAsme.shielding_gas ? wpsAsme.shielding_gas  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Composition %</label>
              <p>{{ wpsAsme.composition_per ? wpsAsme.composition_per  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Flow Rate</label>
              <p>{{ wpsAsme.flow_rate ? wpsAsme.flow_rate  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Gas Backing</label>
              <p>{{ wpsAsme.gas_backing ? wpsAsme.gas_backing  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Nozzle Size</label>
              <p>{{ wpsAsme.nozzle_size ? wpsAsme.nozzle_size  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Trailing Shielding Gas</label>
              <p>{{ wpsAsme.trailing_shielding_gas ? wpsAsme.trailing_shielding_gas  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Electrical Charecterstics (QW-409)</h4><hr>
      <v-row>
        <v-col :cols="colValue" md="3" sm="3" xs="12">
          <label class='view_label'>Tungsten Type</label>
          <p>{{ wpsAsme.tungsten_type ? wpsAsme.tungsten_type  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="3" sm="3" xs="12">
          <label class='view_label'>Tungsten Size</label>
          <p>{{ wpsAsme.tungsten_size ? wpsAsme.tungsten_size  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="3" sm="3" xs="12">
          <label class='view_label'>Torch Angle</label>
          <p>{{ wpsAsme.torch_angle ? wpsAsme.torch_angle  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="3" sm="3" xs="12">
          <label class='view_label'>Current</label>
          <p>{{ wpsAsme.current ? wpsAsme.current  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="3" sm="3" xs="12">
          <label class='view_label'>Model Of Metal Transfer</label>
          <p>{{ wpsAsme.mode_of_metal_transfer ? wpsAsme.mode_of_metal_transfer  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="8" sm="6" xs="12">
          <label class='view_label'>Remarks</label>
          <p>{{ wpsAsme.electrical_char_remark ? wpsAsme.electrical_char_remark  : '-' }}</p>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Technique (QW-410)</h4><hr>
      <v-row>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>String or Weave Bead</label>
              <p>{{ wpsAsme.weave_bead ? wpsAsme.weave_bead  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Orifice / Gas Cup Size</label>
              <p>{{ wpsAsme.gas_cup_size ? wpsAsme.gas_cup_size  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Inital and Interpass Cleaning (Brushing,Grinding)</label>
              <p>{{ wpsAsme.cleaning ? wpsAsme.cleaning  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Method Of Back Gouging</label>
              <p>{{ wpsAsme.back_gouging_method ? wpsAsme.back_gouging_method  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Oscillation Frequency</label>
              <p>{{ wpsAsme.oscillation ? wpsAsme.oscillation  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Contact Tube Work Distance</label>
              <p>{{ wpsAsme.contact_tube_work_distance ? wpsAsme.contact_tube_work_distance  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Multiple Or Single Pass (perside)</label>
              <p>{{ wpsAsme.pass_perside ? wpsAsme.pass_perside  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Multiple Or Single Electrodes</label>
              <p>{{ wpsAsme.electrode ? wpsAsme.electrode  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Peening</label>
              <p>{{ wpsAsme.peening ? wpsAsme.peening  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Electrode Spacing</label>
              <p>{{ wpsAsme.electrode_spacing ? wpsAsme.electrode_spacing  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Welding Parameters</h4><hr>
      <v-row v-for="(wp, ind) in wpsAsme.welding_parameter" :key="`wp_${ind}`" class="pt-5">
        <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Welding Process</label>
              <p><v-chip small>{{ wp.wpm_wps_text ? wp.wpm_wps_text  : '-' }}</v-chip></p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Weld Layer</label>
              <p>{{ wp.weld_layer ? wp.weld_layer  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Class</label>
              <p>{{ wp.filler_class ? wp.filler_class  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Size</label>
              <p>{{ wp.filler_size ? wp.filler_size  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Polarity</label>
              <p>{{ wp.wpm_plr_text ? wp.wpm_plr_text  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Current(A)</label>
              <p>{{ wp.min_current ? wp.min_current  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Current(A)</label>
              <p>{{ wp.max_current ? wp.max_current  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Voltage(V)</label>
              <p>{{ wp.min_voltage ? wp.min_voltage  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Voltage(V)</label>
              <p>{{ wp.max_voltage ? wp.max_voltage  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Travel Speed</label>
              <p>{{ wp.min_travel_speed ? wp.min_travel_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Travel Speed</label>
              <p>{{ wp.max_travel_speed ? wp.max_travel_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Feed Speed</label>
              <p>{{ wp.min_feed_speed ? wp.min_feed_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Feed Speed</label>
              <p>{{ wp.max_feed_speed ? wp.max_feed_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Flow Rate</label>
              <p>{{ wp.min_flowrate ? wp.min_flowrate  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Flow Rate</label>
              <p>{{ wp.max_flowrate ? wp.max_flowrate  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <label class='view_label'>Prepared By</label>
          <p>{{ wpsAsme.prepared_by ? wpsAsme.prepared_by  : '-' }}</p>
          <label class='view_label'>Prepared By Signature</label>
          <p>{{ wpsAsme.prepared_by_sign ? wpsAsme.prepared_by_sign  : '-' }}</p>
          <label class='view_label'>Date</label>
          <p>{{ wpsAsme.prepared_date ? wpsAsme.prepared_date  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <label class='view_label'>Approved By</label>
          <p>{{ wpsAsme.approved_by ? wpsAsme.approved_by  : '-' }}</p>
          <label class='view_label'>Approved By Signature</label>
          <p>{{ wpsAsme.approved_by_sign ? wpsAsme.approved_by_sign  : '-' }}</p>
          <label class='view_label'>Date</label>
          <p>{{ wpsAsme.approved_date ? wpsAsme.approved_date  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12' >
          <label class='view_label'>Status</label>
          <p>
            <template>
              <v-chip :color="wpsAsme.status == 0 ? 'success' : 'warning'" small>{{ wpsAsme.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <v-footer fixed class="d-print-none">
        <v-col class="text-right">
          <v-btn v-if="$checkRight(['edit_welding_procedure'])" color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
          <v-btn color="primary" class="mr-2" @click="print" small v-if="!$vuetify.breakpoint.mdAndDown">Print</v-btn>
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  computed: {
    colValue () {
      return this.$vuetify.breakpoint.mdAndDown ? 12 : undefined
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getWeldingProcedureById/' + id).then((res) => {
        const data = res.data.welding_procedure
        data.wptwpr_id = res.data.wptwpr
        data.wptwt_id = res.data.wptwt
        data.base_metal = res.data.base_metal
        data.filler_metal = res.data.filler_metal
        data.welding_parameter = res.data.welding_parameter
        data.welding_procedure_drawing = res.data.welding_procedure_drawing
        this.wpsAsme = data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      wpsAsme: {},
      error: {}
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/weldingProcedure/wpsAsme/edit/${editId}`, })
    },
    print () {
      window.print()
    }
  }
}
</script>

<style>
.wpsAsmeViewForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.wpsAsmeViewForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.wpsAsmeViewForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
.logo_box {
  border: 1px dotted #ccc;
  max-width: 200px;
}
.upload_container {
  height: auto;
  width: 100%;
}
.wpsAsmeViewForm h4 {
  color: #464d69;
  font-weight: bold;
}
.jointDrawings img{
  max-width: 100%;
}
@media print {
  .break_page { page-break-before: always }
}
</style>
